import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmExperienceSupportWebsiteOverviewRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceSupportWebsiteOverviewRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation } from './ui/support-website-overview/index.tsx';

export const csmExperienceSupportWebsiteOverviewRouteEntry: Route = createEntry(
	csmExperienceSupportWebsiteOverviewRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-support-website.overview',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
			csmHubSetupSupportWebsiteResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
